/**
 * Created by Administrator on 2018-05-03.
 */
import Vue from 'vue'

export default new Vue



























// WEBPACK FOOTER //
// ./src/ask/eventBus.js